@if (loaded) {
  <div class="content">
    <rt-requisitions-toolbar
      [requisition]="requisition"
      [canCreateJob]="canCreateJob"
      [requestApprovalDisabled]="requestApprovalDisabled"
      [hasManageActions]="hasManageActions"
      [hasManageActionsDisabled]="false"
      [hideManageActionsUnderMore]="
        isCurrentUserApproverInAnyStep && requisition.status === RequisitionStatus.Pending
      "
      [hasApproverActions]="isCurrentUserApproverInActiveStep"
      [hasSave]="false"
      (duplicate)="duplicate()"
      (cancelRequest)="cancelRequest()"
      (archive)="archive()"
      (retrieve)="retrieve()"
      (createJob)="createJob()"
      (delete)="delete()"
      (approveRequest)="approveRequest()"
      (rejectRequest)="rejectRequest()"
      (requestApproval)="requestApproval()"
    />

    @if (isFlowEditable && allApproversDeleted) {
      <rt-infobox
        [heading]="'app.requisitions.flow.no_approvers_infobox.heading' | translate"
        iconName="error"
        type="error"
        [isDismissible]="false"
        margin-bottom
      >
        {{ 'app.requisitions.flow.no_approvers_infobox.description' | translate }}
      </rt-infobox>
    }
    @if (
      !!this.requisition?.rejectionReason && this.requisition?.status === RequisitionStatus.Rejected
    ) {
      <rt-requisitions-rejection-infobox margin-bottom />
    }
    @if (approvalFlow) {
      <rt-box variant="default" layout-vertical>
        <div layout layout-space-between margin-bottom>
          <div>
            <rt-heading variant="heading large block">{{
              'app.requisitions.flow.approval_flow' | translate
            }}</rt-heading>
            <div class="description">
              @if (departmentName) {
                <span text-weight-semi-bold
                  >{{ 'app.requisitions.flow.department_label' | translate }}&nbsp;</span
                >{{ departmentName }}<rt-divider variant="dot" />
              }
              <span text-weight-semi-bold
                >{{ 'app.requisitions.flow.flow_label' | translate }}&nbsp;</span
              >
              @if (!approvalFlow.custom) {
                {{ approvalFlow.title }}
              } @else {
                <span
                  [rtTooltip]="'app.requisitions.flow.custom_flow_tooltip' | translate"
                  [rtTooltipHasTextAlignCenter]="true"
                  [rtTooltipMaxWidth]="280"
                  >{{ 'app.requisitions.flow.custom_flow' | translate }}</span
                >
              }
            </div>
          </div>
          <div>
            @if (!isReadOnlyMode) {
              <rt-requisitions-flow-select-container
                [requisitionId]="requisition.id"
                [flows]="availableFlows"
                [assigned]="approvalFlow"
              />
            }
          </div>
        </div>
        @if (approvalFlow) {
          <rt-requisitions-flow-steps-list-container
            [requisitionId]="requisition.id"
            [steps]="approvalFlow.steps"
            [users]="users"
            [isReadOnly]="isReadOnlyMode"
          />
        }
      </rt-box>
    }

    <!--  EMPTY STATE -->
    @if (!approvalFlow && !isDepartmentsMode) {
      <rt-empty-state
        [title]="'app.requisitions.flow.empty_state.doesnt_exist_description' | translate"
        icon="warning"
        [desc]="'app.requisitions.flow.empty_state.doesnt_exist_title' | translate"
        variant="default"
      >
        @if (!isReadOnlyMode) {
          <rt-requisitions-flow-select-container
            [requisitionId]="requisition.id"
            [flows]="availableFlows"
          />
        }
      </rt-empty-state>
    }
    @if (!approvalFlow && isDepartmentsMode) {
      <rt-empty-state
        [title]="
          'app.requisitions.flow.empty_state.doesnt_exist_department_description' | translate
        "
        icon="warning"
        [desc]="'app.requisitions.flow.empty_state.doesnt_exist_department_title' | translate"
        variant="default"
      />
    }
  </div>
} @else {
  <rt-spinner />
}
